import React, { useContext } from 'react';
import {
  makeStyles, Button, Typography, Grid,
} from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import AppContext from '../../state/AppContext';
import clientCategoryState, { clientTypeState } from '../../state';
import {
  preSelectedClinicIdState,
  selectedClinicIdState,
  selectedMedicalFileIdState,
  selectedServiceIdState,
  selectedSubserviceIdState,
  selectedTherapistState,
  selectedTreatmentIdState,
} from '../../state/selected';
import { regionsState, servicesState, therapistsState } from '../../state/apiData';

const useStyles = makeStyles((theme) => ({
  container: {
    border: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.common.white,
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  therapistName: {
    textAlign: 'right',
    marginBottom: theme.spacing(3),
  },
  btn: {},
}));

const FollowUp = (props) => {
  const { followUp } = props;
  const classes = useStyles();
  const intl = useIntl();
  const {
    setIsFollowUp,
  } = useContext(AppContext);

  const therapists = useRecoilValue(therapistsState);
  const services = useRecoilValue(servicesState);
  const regions = useRecoilValue(regionsState);
  const setSelectedTreatmentId = useSetRecoilState(selectedTreatmentIdState);
  const setSelectedTherapist = useSetRecoilState(selectedTherapistState);
  const setSelectedServiceId = useSetRecoilState(selectedServiceIdState);
  const setSelectedSubserviceId = useSetRecoilState(selectedSubserviceIdState);
  const setSelectedMedicalFileId = useSetRecoilState(selectedMedicalFileIdState);
  const setSelectedClinicId = useSetRecoilState(selectedClinicIdState);
  const setClientType = useSetRecoilState(clientTypeState);
  const setClientCategory = useSetRecoilState(clientCategoryState);
  const setPreSelectedClinicId = useSetRecoilState(preSelectedClinicIdState);

  const therapist = therapists ? therapists.filter(
    (t) => (parseInt(t.therapistId, 10) === parseInt(followUp.therapistID, 10)
    ),
  )[0] : null;

  const service = services ? services.filter(
    (s) => (parseInt(s.externalTherapyID, 10) === parseInt(followUp.disciplineID, 10)
    ),
  )[0] : null;

  const subservice = service && service.subServices ? service.subServices.filter(
    (subService) => (
      parseInt(subService.client_type2Id, 10) === parseInt(followUp.subdisciplineID, 10)
    ),
  )[0] : null;

  const region = followUp.regionID && regions ? regions.filter(
    (r) => (parseInt(r.id, 10) === parseInt(followUp.regionID, 10)
    ),
  )[0] : null;

  const onBtnClick = () => {
    if (window && window.gtag) {
      window.gtag('event', 'select_content', {
        content_name: 'Attempt to Book a Follow-up',
        content_lang: intl.locale,
      });
    }
    setIsFollowUp(true);
    setSelectedServiceId(followUp.disciplineID);
    setSelectedSubserviceId(followUp.subdisciplineID);
    setSelectedMedicalFileId(followUp.DmedID);
    setSelectedTherapist(therapist);
    setSelectedTreatmentId(followUp.treatmentID);
    setClientType(followUp.client_type);
    setClientCategory(followUp.client_category);
    setPreSelectedClinicId(followUp.clinicID);
    return setSelectedClinicId(followUp.clinicID);
  };

  return (
    <div className={classes.container}>
      <Grid
        container
        spacing={2}
        justifyContent="space-between"
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <Typography variant="body2" component="div">
            <FormattedMessage id="FollowUpAppointments.followUpIn" />
            {service
              && (
                <>
                  {' '}
                  {service.therapyName[intl.locale].toLowerCase()}
                </>
              )}
          </Typography>
          {service && service.subServices.length > 1 && subservice && (
            <Typography component="div">
              {subservice.subServiceName[intl.locale]}
            </Typography>
          )}
          <Typography component="div">
            {followUp.treatmentName[intl.locale]}
          </Typography>
          {region
            && (
              <Typography component="div">
                <FormattedMessage id="FollowUp.region" />
                {region[`vulgarisation${intl.locale.toUpperCase()}`]}
              </Typography>
            )}
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          {therapist
            && (
              <Typography className={classes.therapistName} component="div">
                {therapist.firstName}
                {' '}
                {therapist.therapistName}
              </Typography>
            )}
          <Button
            className={classes.btn}
            variant="contained"
            color="primary"
            onClick={onBtnClick}
            fullWidth
          >
            <FormattedMessage id="FollowUpAppointments.planFollowUp" />
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

FollowUp.propTypes = {
  followUp: PropTypes.shape({
    disciplineID: PropTypes.number,
    regionID: PropTypes.number,
    subdisciplineID: PropTypes.number,
    clinicID: PropTypes.number,
    therapistID: PropTypes.number,
    treatmentID: PropTypes.number,
    DmedID: PropTypes.number,
    client_type: PropTypes.number,
    client_category: PropTypes.number,
    treatmentName: PropTypes.shape({
      en: PropTypes.string,
      fr: PropTypes.string,
    }),
  }).isRequired,
};

export default FollowUp;
